<template>
  <section>
    <!-- banner部分 -->
    <v-sub_banner :msgObj="subBannerInfo"></v-sub_banner>
    <!-- 简介部分 -->
    <b-container fluid>
      <b-row class="justify-content-center abouts-us-Info">
        <b-col
          cols="12"
          class="text-center flex-column justify-content-top d-flex"
        >
          <b-container fluid>
            <!-- style="background: #fcc;" -->
            <b-row class="justify-content-center">
              <b-col
              cols="12"
              sm="10"
              md="9"
                lg="8"
               
                class="text-center flex-column justify-content-center d-flex"
              >
                <b-container fluid>
                  <b-row class="justify-content-center">
                    <b-col
                      cols="4"
                     
                      class="text-center flex-column justify-content-center d-flex"
                    >
                      <figure class="figure">
                        <img
                          src="@/assets/images/about-us/email.png"
                          class="figure-img img-fluid"
                          alt=""
                        />
                        <figcaption class="figure-caption caption-title1">
                          邮箱
                        </figcaption>
                        <figcaption class="figure-caption caption-title">
                          caacic@caac.gov.cn
                        </figcaption>
                      </figure>
                    </b-col>
                    <b-col
                  
                      cols="4"
                      class="text-center flex-column justify-content-center d-flex"
                    >
                      <figure class="figure">
                        <img
                          src="@/assets/images/about-us/dingwei.png"
                          class="figure-img img-fluid"
                          alt=""
                        />
                        <figcaption class="figure-caption caption-title1">
                          地址
                        </figcaption>
                        <figcaption class="figure-caption caption-title">
                          北京市东城区东四西大街155号
                        </figcaption>
                      </figure>
                    </b-col>
                    <b-col
                      cols="4"
                    
                      class="text-center flex-column justify-content-center d-flex"
                    >
                      <figure class="figure">
                        <img
                          src="@/assets/images/about-us/fax.png"
                          class="figure-img img-fluid"
                          alt=""
                        />
                        <figcaption class="figure-caption caption-title1">
                          传真
                        </figcaption>
                        <figcaption class="figure-caption caption-title">
                          64092853
                        </figcaption>
                      </figure>
                    </b-col>
                  </b-row>
                </b-container>
              </b-col>
            </b-row>
          </b-container>
        </b-col>
      </b-row>
    </b-container>
  </section>
</template>
<script>
import Sub_banner from "../sub-banner.vue";
export default {
  components: {
    "v-sub_banner": Sub_banner,
  },
  data() {
    return {
      subBannerInfo: {
        // img: require("@/assets/images/sub_banner/lxwm.png"),
        img:require("@/assets/images/connect_banner.png"),
        title:'联系我们',
        subTitle:'Contact us'
      },
      screenWidth: 0,
    };
  },
  watch: {},
  created() {},
  mounted() {
    this.screenWidth = window.innerWidth;
    this.setReSize();
    // 窗口大小发生改变时,调用一次
    window.onresize = () => {
      this.screenWidth = window.innerWidth;
      this.setReSize();
    };
  },
  methods: {
    setReSize() {
      if (this.screenWidth > 576) {
        this.subBannerInfo.img = require("@/assets/images/connect_banner.png");
      } else {
        this.subBannerInfo.img = require("@/assets/images/common_m.png");
      }
    },
  },
};
</script>
<style scoped>
@import "../../assets/css/about-us.css";
</style>
<style lang="less" scoped>
@media (max-width: 575px) {
  .abouts-us-Info {
    height: calc(1000px * 0.35);
  }
  .abouts-us-Info img {
    padding-top: 25%;
    width: 38%;
  }
  .caption-title1 {
    font-size: 12px;
    line-height: 1.8;
  }
  .caption-title {
    font-size: 13px;
  }
}

/* // Small devices (landscape phones, 576px and up) */
@media (min-width: 576px) and (max-width: 767px) {
  .abouts-us-Info {
    height: calc(1000px * 0.5);
  }
  .abouts-us-Info img {
    padding-top: 25%;
    width: 36%;
  }
  .caption-title1 {
    font-size: 14px;
    line-height: 1.925;
  }
  .caption-title {
    font-size: 15px;
  }
}

/* // Medium devices (tablets, 768px and up) */
@media (min-width: 768px) and (max-width: 991px) {
  .abouts-us-Info {
    height: calc(1000px * 0.6);
  }
  .abouts-us-Info img {
    padding-top: 25%;
    width: 34%;
  }
  .caption-title1 {
    font-size: 15px;
    line-height: 1.925;
  }
  .caption-title {
    font-size: 17px;
  }
}

/* // Large devices (desktops, 992px and up) */
@media (min-width: 992px) and (max-width: 1199px) {
  .abouts-us-Info {
    height: calc(1000px * 0.7);
  }
  .abouts-us-Info img {
    padding-top: 30%;
    width: 30%;
  }
}

/* // Extra large devices (large desktops, 1200px and up) */
@media (min-width: 1200px) {
}
.figure{
  height: 100%;
}
</style>
